/* eslint-disable */
import React from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const EventFeedbackRuleHeader = ({
  reloadList = () => {},
  deleteBulk = () => {},
}) => {
  const { t } = useTranslation();
  const params = useParams();

  return (
    <div className="filter-container py-3">
      <div className="row align-items-center">
        {/* ---- search start ---- */}
        <div className="col-md-5 d-none d-md-block">
          <ul
            className="nav nav-tabs d-inline-flex p-1 body-bg flex-nowrap fs-md lh-1 fw-semibold border-0 text-nowrap rounded-10"
            id="mailTab"
          >
            <li className="nav-item" role="presentation">
              <Link
                to={`/admin/events/feedbackrules/${params.id}`}
                className="text-black d-flex align-items-center justify-content-center gap-2 rounded-10 active"
              >
                <span className="d-block material-symbols-outlined icon-lg">
                  archive
                </span>
                <span className="d-block">{t("Feedback Rules")}</span>
              </Link>
            </li>
            <li className="nav-item" role="presentation">
              <Link
                to={`/admin/events/feedbackgiven/${params.id}`}
                className="text-black d-flex align-items-center justify-content-center gap-2 rounded-10"
              >
                <span className="d-block material-symbols-outlined icon-lg">
                  unarchive
                </span>
                <span className="d-block">{t("Feedback Given")}</span>
              </Link>
            </li>
          </ul>
        </div>
        {/* ---- search end ---- */}

        <div className="col-md-7 d-flex justify-content-end gap-1 gap-sm-2">
          <Link
            onClick={reloadList}
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            title={t("Reload")}
          >
            <span className="material-symbols-outlined icon-md me-1">
              refresh
            </span>
            <span className="fw-semibold small">{t("Reload")}</span>
          </Link>
          {/* --- action start --- */}
          <div className="dropdown flex-fill flex-grow-sm-0">
            <button
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="fw-semibold small">{t("Action")}</span>
              <span className="material-symbols-outlined icon-lg ms-1">
                expand_more
              </span>
            </button>
            <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
              <li>
                <Link
                  to="#"
                  className="dropdown-item d-flex align-items-center gap-2"
                  data-bs-toggle="modal"
                  data-bs-target="#addLabelModal"
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    label
                  </span>
                  <span className="d-block">Add Label</span>
                </Link>
              </li>
              <li>
                <Link
                  to="#"
                  className="dropdown-item d-flex align-items-center gap-2"
                  data-bs-toggle="modal"
                  data-bs-target="#deletewarning"
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    delete
                  </span>
                  <span className="d-block">Delete</span>
                </Link>
              </li>
            </ul>
          </div>
          {/* --- action end --- */}

          <Link
            to="#"
            className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#feedbackRuleFilter"
            aria-controls="feedbackRuleFilter"
          >
            <span className="material-symbols-outlined icon-md me-1">tune</span>
            <span className="fw-semibold small">{t("Filter")}</span>
          </Link>
          <Link
            to="#"
            className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-3 shadow-sm fw-semibold"
            data-bs-toggle="offcanvas"
            data-bs-target="#savefeedbackrule"
            role="button"
            aria-controls="savefeedbackrule"
          >
            <span className="material-symbols-outlined icon-md">add</span>
            <span>{t("Add New")}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EventFeedbackRuleHeader;
